import { Link, useLocation } from "react-router-dom";
import { MapPin } from "lucide-react";

export const MobileBar = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/checkout") || pathname.startsWith("/account") || pathname.startsWith("/admin")) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-[#232323] bg-[#080808]/90 backdrop-blur-xl lg:hidden" data-testid="mobile-sticky-bar">
      <div className="flex gap-3 px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
        <Link to="/delivery-areas#check" className="lc-btn-ghost flex-1 !py-3" data-testid="mobile-bar-postcode">
          <MapPin className="h-4 w-4" /> Postcode
        </Link>
        <Link to="/plans" className="lc-btn-primary flex-[1.4] !py-3" data-testid="mobile-bar-plans">Explore plans</Link>
      </div>
    </div>
  );
};
